import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';

const SettingBoundariesFinalThoughts = () => (
  <div className="space-y-8">
    <PlaybookSection title="Final Thoughts" icon={<SparklesIcon className="h-7 w-7 text-primary-light" />} heading>
      <div className="prose prose-invert max-w-none">
        <p className="text-lg">
          Setting effective boundaries for yourself and your team starts with getting clarity and then alignment on what your team is accountable for and what their purpose is in terms of delivering value for the organisation. By being explicit here and sharing that with the wider organisation you set up the foundations for clear expectation management and more inter-team empathy.
        </p>
      </div>
    </PlaybookSection>
  </div>
);

export default SettingBoundariesFinalThoughts; 